import axios from "./axiosinstance";

const PaymentApi = {
  list: (params) => axios.get("payment/list", { params }),
};

export default PaymentApi;  